import { GET_DISPUTES, GET_DISPUTES_SUCCESS, GET_DISPUTES_FAILURE, EXPORT_DISPUTES, EXPORT_DISPUTES_SUCCESS, EXPORT_DISPUTES_FAILURE, DISPUTE_DETAIL, DISPUTE_DETAIL_SUCCESS, DISPUTE_DETAIL_FAILURE } from "../constants";

export default class DisputeActions {

    static getAllDisputes(payload, cb) {
        return {
            type: GET_DISPUTES,
            payload,
            cb,
        };
    }

    static getAllDisputesSuccess(payload) {
        return {
            type: GET_DISPUTES_SUCCESS,
            payload,
        };
    }

    static getAllDisputesFailure() {
        return {
            type: GET_DISPUTES_FAILURE,
        };
    }

    static exportDisputes(payload, cb) {
        return {
            type: EXPORT_DISPUTES,
            payload,
            cb,
        };
    }

    static exportDisputesSuccess(payload) {
        return {
            type: EXPORT_DISPUTES_SUCCESS,
            payload,
        };
    }

    static exportDisputesFailure() {
        return {
            type: EXPORT_DISPUTES_FAILURE,
        };
    }

    static disputeDetail(payload, cb) {
        console.log(payload)
        return {
            type: DISPUTE_DETAIL,
            payload,
            cb,
        };
    }

    static disputeDetailSuccess(payload) {
        return {
            type: DISPUTE_DETAIL_SUCCESS,
            payload,
        };
    }

    static disputeDetailFailure() {
        return {
            type: DISPUTE_DETAIL_FAILURE,
        };
    }

}